import RouteNames from '../constants/route-names';

const backButtonNavigation = from => ((from.name === RouteNames.AppointmentCreateAccount)
  ? RouteNames.AppointmentEmail
  : null);

export default { backButtonNavigation };
